import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractEntryCommand from "./AbstractEntryCommand.js";
import getNamedCommandHeading from "../getNamedCommandHeading.js";
import selection from "../selection.js";

/**
 * `DeleteCommand` is the command in charge of the deletion of*
 * entries. To be valid, the selection should not be empty and should
 * contain only deletable entries.
 */
export default class DeleteCommand extends AbstractEntryCommand {
	accept(aVisitor) {
		return aVisitor.visitDeleteCommand(this);
	}

	requireRefresh() {
		return true;
	}

	priority() {
		return 400;
	}

	heading() {
		return getNamedCommandHeading("Actions");
	}

	entryType() {
		if (selection.isSingleSelection()) {
			if (this._entry.isFile()) {
				return _("file");
			}
			return _("folder");
		}
		return _("items");
	}

	_performOnService(callback) {
		this._documentService.executeDeleteCommand(this, callback);
	}

	_execute() {
		const entries = selection.entries();

		// All the selected items belong to the same folder
		const parent = entries[0].parent();
		parent.removeChildren(entries);
	}

	static isApplicable() {
		return (
			selection.notEmpty() &&
			selection.every((each) => each.entry().canBeDeleted())
		);
	}
}
